// 指标监控：嵌入 Grafana 仪表盘
import { t } from '@lib/i18n';

const GRAFANA_URL = '/grafana/d/g7rs5x/pi?orgId=1&kiosk=true';

export function FullMetrics() {
  return (
    <div className="flex flex-col h-full min-h-0">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="text-xl font-semibold text-white">{t('dashboard.metrics')}</h2>
      </div>
      <div className="flex-1 min-h-0 rounded-xl overflow-hidden border border-dark-800 bg-dark-900/50 shadow-lg">
        <iframe
          src={GRAFANA_URL}
          title={t('dashboard.metrics')}
          className="w-full h-full block"
          style={{ border: 0, minHeight: 'calc(100vh - 180px)' }}
          allow="fullscreen"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  );
}

export default FullMetrics;
